/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minimum_Outside_Air_Dampers_SetpointInputs */



/**
* | output |
* | --- |
* | "Minimum fresh air damper intake" |
*
* @param {Minimum_Outside_Air_Dampers_SetpointInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const minimum_outside_air_dampers_setpoint = /** @type {((inputs?: Minimum_Outside_Air_Dampers_SetpointInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minimum_Outside_Air_Dampers_SetpointInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Minimum fresh air damper intake")
	return /** @type {LocalizedString} */ ("Apport minimum volet air neuf")
});